import React from 'react'
import PropTypes from 'prop-types';
import TextInput from './TextInput.jsx';

export default class NumericInput extends React.Component {

  static propTypes = {
    onChange : PropTypes.func,
    changeOnBlur : PropTypes.bool,
    changeOnReturn : PropTypes.bool,
    hint : PropTypes.string,
    value : PropTypes.number,
    min : PropTypes.number,
    max : PropTypes.number,
    maxLength : PropTypes.number,
    size : PropTypes.number,    
    focus : PropTypes.bool

  }

  constructor( props ) {
    super( props );
    this.acceptKey = this.acceptKey.bind( this );
    this.validator = this.validator.bind( this );
    this.onChange = this.onChange.bind( this );
  }

  acceptKey( evt ) {
    const start = evt.target.selectionStart;
    const stop = evt.target.selectionEnd;
    const val = evt.target.value;
    const inp = String.fromCharCode( evt.charCode );

    if ( inp == '-' && this.props.min == null || ( this.props.min != null && this.props.min < 0 ) ) {
      // allow negative at beginning
      if ( start != 0 ) {
        return false;
      }
      const negIndex = val.indexOf( '-' );
      if ( ( negIndex == 0 && stop == 0 ) ) {
        return false;
      }
      return true;
    }

    const c = evt.charCode;
    if ( this.props.float ) {
      const dotIndex = val.indexOf( '.' );

      if ( inp == '.' && dotIndex >= 0 ) {
        if ( stop - start == 1 && dotIndex == start ) {
          return true; // replace dot with dot.
        }
        if ( !( start <= dotIndex && dotIndex < stop ) ) {
          return false; // cant have 2 dots
        }
      }
      if ( /[0-9.]/.test( inp ) ) {
        return true;
      }
    } else if ( /[0-9]/.test( inp ) ) {
      return true;
    }
    return false;
  }

  validator( val ) {
    if ( val == null || val == '' ) {
      return true;
    }
    const v = parseFloat( val );
    if ( isNaN( v ) ) {
      return false;
    }
    if ( this.props.min != null && v < this.props.min ) {
      return false;
    }
    if ( this.props.max != null && v > this.props.max ) {
      return false;
    }
    return true;
  }

  onChange( val, err ) {
    try {
      const v = val == null ? null : parseFloat( val );
      if ( this.props.onChange ) {
        this.props.onChange( v, err );
      }
    } catch ( ex ) {
      console.log( 'error parsing', val, err, ex );
    }
  }

  render() {
    const props = {
      className : this.props.className,
      style : this.props.style,
      size : this.props.size,
      maxLength : this.props.maxLength,
      onChange : this.onChange,
      validator : this.validator,
      acceptKey : this.acceptKey,
      changeOnReturn : this.props.changeOnReturn,
      changeOnBlur : this.props.changeOnBlur,
      hint : this.props.hint,
      focus : this.props.focus,
      value : this.props.value == null ? '' : `${this.props.value}`
    }
    return ( <TextInput {...props} /> );
  }
  
}
